import { Text } from "@marketplace/ui";
import { useTranslation } from "react-i18next";
import { MdAutorenew } from "react-icons/md";

export const RecurringBadge = () => {
  const { t } = useTranslation("order", {
    keyPrefix: "orderListPage"
  });

  return (
    <div className="rounded-full mt-1 lg:mt-0 p-1 bg-[#FFF5DE] text-[#BD8606] flex items-center gap-x-[2px]">
      <MdAutorenew size={16} />
      <Text size="s">{t("recurringOrder")}</Text>
    </div>
  );
};
